import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/empresa?${serialize(filtros)}`, { tela: 'empresa' })
}

export async function get (id) {
  return httpAuth.get(`/empresa/${id}`, { tela: 'empresa' })
}

export async function add (dados) {
  return httpAuth.post(`/empresa`, dados, { funcionalidade: 'empresa_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/empresa/${id}`, dados, { funcionalidade: 'empresa_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/empresa/${id}`, { funcionalidade: 'empresa_excluir' })
}
